import axiosInstance from './axios';

export const routineService = {
    // Day Types
    getDayTypes: () => axiosInstance.get('/api/routine/day-types'),
    createDayType: (data) => axiosInstance.post('/api/routine/day-types', data),
    updateDayType: (id, data) => {
        console.log('Updating day type:', id, data); // Debug log
        return axiosInstance.patch(`/api/routine/day-types/${id}`, data);
    },
    deleteDayType: (id) => axiosInstance.delete(`/api/routine/day-types/${id}`),

    // Routines
    getRoutines: (dayTypeId) => axiosInstance.get(`/api/routine/routines?dayType=${dayTypeId}`),
    createRoutine: (data) => axiosInstance.post('/api/routine/routines', data),
    updateRoutine: (id, data) => axiosInstance.put(`/api/routine/routines/${id}`, data),
    deleteRoutine: (id) => axiosInstance.delete(`/api/routine/routines/${id}`)
};
